import axios from 'axios';
import * as actionTypes from './Actiontypes';

const BASE_URL = "https://api.happiclips.com/api"

export const add_guest = (account_type, event_id, first_name, last_name, email, phone) => {
    const payload = { account_type, event_id, first_name, last_name, email, phone };

    return async (dispatch) => {
        dispatch({ type: actionTypes.ADD_GUEST_INIT });

        try {
            const authToken = localStorage.getItem('authToken');

            const res = await axios.post(`${BASE_URL}/guests/create`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });

            if (!res.data.success) {
                throw new Error(res.data.message || "Something went wrong!");
            }

            dispatch({
                type: actionTypes.ADD_GUEST_SUCCESS,
                payload: res.data
            });

        } catch (error) {

            dispatch({
                type: actionTypes.ADD_GUEST_FAIL,
                payload: error.message || 'error'
            });

            throw error;
        }
    };
};


export const view_guest = (page, search = "", account_type = "", event_id = "") => {
    const payload = {
        search, account_type, event_id
    }
    return async (dispatch) => {
        dispatch({
            type: actionTypes.VIEW_GUEST_INIT
        })

        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/guests?page=${page}`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.VIEW_GUEST_SUCCESS,
                payload: res.data
            })
            //  console.log(res.data)

        }
        catch (error) {
            dispatch({
                type: actionTypes.VIEW_GUEST_FAIL,
                payload: 'error'
            })
        }
    }

}

export const delete_guest = (id, payload) => {

    return async (dispatch) => {
        dispatch({
            type: actionTypes.DELETE_GUEST_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/guests/delete/${id}`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.DELETE_GUEST_SUCCESS,
                payload: res.data
            })


        }
        catch (error) {
            dispatch({
                type: actionTypes.DELETE_GUEST_FAIL,
                payload: 'error'
            })
            // toast.error("Please fill all files")
        }
    }

}

export const update_guest = (id, payload) => {

    return async (dispatch) => {
        dispatch({
            type: actionTypes.UPDATE_GUEST_INIT
        })
        try {
            const authToken = localStorage.getItem('authToken');
            const res = await axios.post(`${BASE_URL}/guests/update/${id}`, payload, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            dispatch({
                type: actionTypes.UPDATE_GUEST_SUCCESS,
                payload: res.data
            })
        }
        catch (error) {
            dispatch({
                type: actionTypes.UPDATE_GUEST_FAIL,
                payload: 'error'
            })
        }
    }

}